import { useQuery } from "@tanstack/react-query";
import { get } from "@/lib/api";

const TYPE_LABELS = { spend: "Harcama", purchase: "Satın Alma", refund: "İade" };

export default function Credits() {
  const { data: txs = [] } = useQuery({ queryKey: ["admin-credit-tx"], queryFn: () => get("/admin/credit-transactions") });

  return (
    <div>
      <h1 className="text-2xl font-semibold tracking-tight">Kredi İşlemleri</h1>
      <p className="text-sm text-[#475569]">Platform kredi hareketleri · {txs.length} işlem</p>

      <div className="mt-5 overflow-hidden rounded border border-[#CBD5E1] bg-white">
        <table className="w-full text-sm">
          <thead className="bg-[#E2E8F0] text-left text-xs uppercase tracking-wide text-[#475569]">
            <tr><th className="px-4 py-2.5">Kullanıcı</th><th className="px-4 py-2.5">Tür</th><th className="px-4 py-2.5">Açıklama</th><th className="px-4 py-2.5">Tarih</th><th className="px-4 py-2.5 text-right">Tutar</th></tr>
          </thead>
          <tbody className="divide-y divide-[#F1F5F9]">
            {txs.map((t) => (
              <tr key={t.id} className="hover:bg-[#F8FAFC]">
                <td className="px-4 py-2.5 font-medium">{t.user_name}</td>
                <td className="px-4 py-2.5 text-[#475569]">{TYPE_LABELS[t.type] || t.type}</td>
                <td className="px-4 py-2.5 text-[#475569]">{t.note}</td>
                <td className="px-4 py-2.5 text-[#475569]">{new Date(t.created_at).toLocaleDateString("tr-TR")}</td>
                <td className={`px-4 py-2.5 text-right font-semibold ${t.amount < 0 ? "text-rose-600" : "text-emerald-600"}`}>{t.amount > 0 ? "+" : ""}{t.amount}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
